import React, { useState, useEffect } from 'react'
import logo from '../assets/images/g8.webp'
import { NavLink, Link, useLocation,useNavigate } from 'react-router-dom'
import Servicebanner from '../components/Ourservices/Servicebanner'

const Navbar = ({ }) => {
  const navigate = useNavigate();
  const handleMainLinkClick = (event) => {
    event.preventDefault(); 
    navigate("/?id=Services"); 
  };
  const [isscroll, setisscroll] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handlescroll = () => {
      if (window.scrollY > 0) {
        setisscroll(true)
      }
      else {
        setisscroll(false)
      }
    };
    window.addEventListener('scroll', handlescroll);
    return () => {
      window.removeEventListener('scroll', handlescroll)
    };
  }, []);
  const handleLinkClick = () => {
    setIsOpen(false);
    // window.scrollTo(0, 0);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return (
    <div className={`positionnav ${isscroll ? 'scrolled' : ''}`}>
      <section>  
          <nav class="navbar navbar-expand-lg nav-padding">
            <div class="container">
              <a class="navbar-brand">
                <Link to="/?id=Home">
                  <img src={logo} className='logowidth' alt='logo' />
                </Link>
              </a>
              <button class="navbar-toggler" type="button" onClick={() => setIsOpen(!isOpen)} data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarSupportedContent">
                <ul class="navbar-nav ms-auto nav-gap mb-2 mb-lg-0">
                  <li class="nav-item">
                    <Link class="nav-link  nav-style" to="/?id=Home" onClick={handleLinkClick}>Home</Link>
                  </li>
                
                  {/* <li class="nav-item">
          <NavLink class="nav-link nav-style" to="/Services">Our Services</NavLink>
        </li> */}
                  {/* <li class="nav-item dropdown">
                    <a class="nav-link nav-style dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                      Our Services
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                      <li><Link class="dropdown-item" to="/Serviceforwarding" onClick={handleLinkClick}>Freight Forwarding</Link></li>
                      <li><Link class="dropdown-item" to="/Serviceinspection" onClick={handleLinkClick}>Vessel Inspection</Link></li>
                      <li><Link class="dropdown-item" to="/Servicetrading" onClick={handleLinkClick}>General Trading</Link></li>
                    </ul>
                  </li> */}
                   <li className="nav-item dropdown">
      <Link
        className="nav-link nav-style dropdown-toggle"
       to="/?id=Services"
        id="navbarDropdown"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        onClick={handleMainLinkClick}
      >
        Our Services
      </Link>
      <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
        <li>
          <Link className="dropdown-item"to="/Service/forwarding">
            Freight Forwarding
          </Link>
        </li>
        <li>
          <Link className="dropdown-item"to="/Service/inspection">
            Vessel Inspection
          </Link>
        </li>
        <li>
          <Link className="dropdown-item" to="/Service/trading">
            General Trading
          </Link>
        </li>
      </ul>
    </li>



                  <li class="nav-item">
                    <Link class="nav-link nav-style" to="/?id=Mission" onClick={handleLinkClick}>Mission & Vision</Link>
                  </li>
                  <li class="nav-item">
                    <Link class="nav-link nav-style" to="/?id=AboutUs" onClick={handleLinkClick}>About</Link>
                  </li>
                  <li class="nav-item">
                    <Link class="nav-link nav-style" to="/?id=Team" onClick={handleLinkClick}>Team</Link>
                  </li>

                </ul>
                <button className='contact'>
                  <div class="nav-item ">
                    <Link class="nav-link " to="/?id=Contactus" onClick={handleLinkClick}>Contact Us</Link>
                  </div>
                </button>
              </div>
            </div>
          </nav>
      </section>
    </div>
  )
}

export default Navbar
